<template>
    <div>
        <TinyBox v-model="index" :images="images"/>
        <img
            :height="getHeight"
            v-for="(img, idx) in images"
            :src="img.thumbnail"
            :alt="img.alt"
            class="open-tinybox"
            @click="index = idx"
        />
    </div>
</template>

<script>

import TinyBox from "vue-tinybox";
import ImageService from "../../Models/imageModels/ImageService.ts";
import Image from "../../Models/imageModels/Image.ts";

export default {
    components: {
        TinyBox
    },
    props: {
        column: {
            type: Object,
        },
        config: {
            Type: Object,
            default: function () {
                return {
                    height: null,
                    columnData: null, //Data column name default get from column.data
                }
            }
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {
            columnData: null,
            images: [],
            height: null,
            index: null,
        };
    },
    computed: {
        getHeight() {
            return this.height || 40;
        },
    },
    mounted() {
        this.init();
        this.setImages();
    },
    methods: {
        init() {
            this.height = this.config.height;
            this.columnData = this.config.columnData || this.column.data;
        },
        setImages() {
            let images = this.row[this.columnData || 'images'];
            let imagesService = new ImageService();
            images  = JSON.parse(images);

            for (const key in images) {
                let src = images[key]['src'];
                let caption = images[key]['caption'] || '';
                let alt = images[key]['alt'] || '';
                let thumbnail = images[key]['thumbnail'] || '';
                imagesService.add(new Image(src, caption, alt, thumbnail));
            }

            this.images = imagesService.getAll();
        },
    }
}
</script>


<style lang="sass" scoped>
    .open-tinybox {
        cursor: zoom-in;
    }
</style>



// WEBPACK FOOTER //
// TinyboxImageComponent.vue?d5326984